namespace Nobox {
    export interface Quota {
        Channel?: string;
        Period?: string;
        Action?: string;
        Tgl?: number[];
    }
}
